import React from "react";
import { getContrastTextColorHEX, checkForColor} from "../../utils/getContrastTextColor";

const CustomerTag = (props) => {
  return (
    <div
      style={{
        display: "block",
        marginRight: 5,
        marginTop: 5,
        fontSize: "80%",
        backgroundColor: props.color,
        color: getContrastTextColorHEX(props.color),
        paddingTop: 1,
        paddingBottom: 1,
        paddingLeft: 4,
        paddingRight: 4,
        textAlign: "center",
        justifyContent: "center",
        alignSelf: "flex-start",
        borderRadius: 3,
        border: `1px solid ${checkForColor(props.color)}`,
      }}
    >
      {props.label}
    </div>
  );
};

export default CustomerTag;
